/**
 * Parses a numeric Shopify id out of a number, numeric string, or GID
 * (`gid://shopify/ProductVariant/123`, `gid://shopify/Market/7?x=y`).
 */
export function toNumericId(value: number | string): number {
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) throw new TypeError(`[Stoq] Invalid id: ${value}`)
    return value
  }
  const trimmed = value.trim()
  const gidMatch = /\/(\d+)(?:\?.*)?$/.exec(trimmed)
  const raw = gidMatch ? gidMatch[1]! : trimmed
  const parsed = Number(raw)
  if (!Number.isFinite(parsed) || raw === '') {
    throw new TypeError(`[Stoq] Cannot parse a numeric id from "${value}"`)
  }
  return parsed
}

/**
 * Normalizes a locale the same way the theme embed does (matches the
 * backend's Mobility.normalize_locale): lowercase, hyphens to underscores.
 * Returns undefined for blank input.
 */
export function normalizeLocale(locale?: string): string | undefined {
  if (!locale || locale.trim() === '') return undefined
  return locale.toLowerCase().replace(/-/g, '_')
}

/** Removes undefined/null entries from a plain object. */
export function compact<T extends Record<string, unknown>>(obj: T): Partial<T> {
  const out: Partial<T> = {}
  for (const key of Object.keys(obj) as Array<keyof T>) {
    const value = obj[key]
    if (value !== undefined && value !== null) out[key] = value
  }
  return out
}

/** console.warn that survives exotic environments. */
export function warn(...args: unknown[]): void {
  if (typeof console !== 'undefined' && typeof console.warn === 'function') {
    console.warn('[Stoq]', ...args)
  }
}
